import type { HTMLAttributes } from "react";
import { useDelayedFlag } from "../effects/hooks";
import { cn } from "../lib/cn";

/** Static placeholder bar. No shimmer: an idle screen should not animate. */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLSpanElement>) {
  return (
    <span aria-hidden className={cn("block h-2.5 rounded-pill bg-fill-1", className)} {...props} />
  );
}

/**
 * True once a wait has lasted `afterMs` (default 300 ms). Show skeletons only then, so fast
 * answers never flash a placeholder.
 */
export function useSlowWait(waiting: boolean, afterMs = 300): boolean {
  return useDelayedFlag(waiting, afterMs);
}
